'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var TextLink = require('@narvar/nth-bit-text-link');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var index = require('../../../../../../common/components/Icon/index.js');
var Box = require('../../../../../../common/components/layout/Box/Box.js');
var OTPProvider = require('./OTPProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);

const OTPNav = () => {
  const {
    linksNoneDefault,
    linksNoneHover
  } = nthHookTheme.useTheme();
  const {
    handleNavigateBack
  } = OTPProvider.useOTP();
  const {
    claimsOtpBack
  } = nthHookTranslations.useTranslations();
  return /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    linkStyle: {
      sDefault: {
        ...linksNoneDefault,
        display: 'flex',
        alignItems: 'center',
        gap: '0.25rem'
      },
      sHover: linksNoneHover
    },
    onClick: handleNavigateBack
  }, /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    display: "flex",
    gap: 2,
    style: {
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    icon: "ArrowLeft",
    "aria-hidden": "true"
  }), claimsOtpBack));
};
var OTPNav$1 = nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(OTPNav, {
  themeTokens: ['linksNoneDefault', 'linksNoneHover']
}), {
  translationKeys: ['claimsOtpBack']
});

exports["default"] = OTPNav$1;
